export default __webpack_public_path__ + "static/media/sc_img_sdg.cb4ec537.png";